
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goautowarranty/[genericRoute]/[keyword]",
      function () {
        return require("private-next-pages/goautowarranty/[genericRoute]/[keyword].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goautowarranty/[genericRoute]/[keyword]"])
      });
    }
  